import type { ReactNode } from "react";
import { Outlet } from "react-router-dom";

type LayoutAdministrareProps = {
  titlu: string;
  descriere?: ReactNode;
};

export function LayoutAdministrare({
  titlu,
  descriere,
}: LayoutAdministrareProps) {
  return (
    <div className="container mx-auto max-w-[1400px] space-y-6 p-6">
      <div className="space-y-1">
        <h1 className="text-3xl font-heading font-bold">{titlu}</h1>
        {descriere && (
          <p className="max-w-3xl text-muted-foreground">{descriere}</p>
        )}
      </div>
      <Outlet />
    </div>
  );
}
